import React, { useMemo } from 'react';
import { Chat, SendStatusEnum, smartDate } from '@matap/shared';
import styled, { useTheme } from 'styled-components/native';
import { AppIconButton } from '@/components/base/app.icon.button';
import { AppTextView } from '@/components/base/app.text.view';
import { Box } from '@/components/base/box';

interface Props {
  chat: Chat;
  isSentByUser: boolean;
}
function BaseChatFooterView({ chat, isSentByUser }: Props) {
  const theme = useTheme();
  const Component = useMemo(() => {
    switch (chat.sendStatus) {
      case SendStatusEnum.SENT:
        return <AppIconButton icon={'check'} size={'small'} color={theme.colors.jade} />;
      case SendStatusEnum.FAILED:
        return <AppIconButton icon={'fail'} size={'small'} color={theme.colors.error} />;
      case SendStatusEnum.DELIVERED:
        return <AppIconButton icon={'double_check'} size={'small'} color={theme.colors.jade} />;
      default:
        return null;
    }
  }, [chat.sendStatus, theme.colors]);

  const dateText = useMemo(() => smartDate(chat.createdAt).persian().format('hh:mm a'), [chat.createdAt]);

  return (
    <Container flexDirection={'row'} justifyContent={'flex-end'}>
      {chat.editedAt && <EditedLabel text={'ویرایش شده'} textColor={'faded'} />}
      <DateText textColor={'faded'} font={'app_english'} text={dateText} />
      {isSentByUser && <DeliveryContainer>{Component}</DeliveryContainer>}
    </Container>
  );
}

const Container = styled(Box)`
  margin-top: 6px;
  min-width: 90px;
  align-items: center;
  flex-direction: row;
`;

const EditedLabel = styled(AppTextView)`
  font-size: 10px;
  margin-right: 8px;
`;

const DateText = styled(AppTextView)`
  font-size: 12px;
  margin-right: 6px;
`;

const DeliveryContainer = styled(Box)`
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
`;

export const ChatFooterView = React.memo(BaseChatFooterView);
